const accSingleTriggers = document.querySelectorAll('.js-acc-single-trigger');

accSingleTriggers.forEach(trigger => trigger.addEventListener('click', toggleAccordion));

function toggleAccordion() {
  const items = document.querySelectorAll('.js-acc-item');
  const thisItem = this.parentNode;

  items.forEach(item => {
    if (thisItem == item) {
      console.log(thisItem.querySelector(".accordion-single-content .metafield-rich_text_field").clientHeight);
      if(thisItem.classList.contains("is-open")) {
        thisItem.classList.remove('is-open');
        thisItem.querySelector(".accordion-single-content").style.maxHeight = "0";
      }else {
        thisItem.classList.add('is-open');
        thisItem.querySelector(".accordion-single-content").style.maxHeight = thisItem.querySelector(".accordion-single-content .metafield-rich_text_field").clientHeight + 50 + "px";
      }
      return;
    }

    item.querySelector(".accordion-single-content").style.maxHeight = "0";
    item.classList.remove('is-open');
  });
}
/* chintan added code start */

const buttons = document.querySelectorAll('.scrollButton');
if(buttons){
  buttons.forEach(button => {
    button.addEventListener('click', function() {
      const section = document.getElementById('buy-section');
      section.scrollIntoView({ behavior: 'smooth' });
    });
  });
}
/* chintan added code end */